import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { QA_NAME_PROFILE_INFO_ITEM_VALUE } from '../../../constants/qa'
import { useContentOverflow } from '../../../hooks'
import { FloatingTooltip } from '../../Floating'
import Text from '../../Text'
import { EntityProfileHeaderInfoItemBase } from '../EntityProfileHeaderInfoItemBase'

function EntityProfileHeaderInfoItemText({
  noDataText = 'Profile.NoCategoryTextKey',
  ref,
  tooltipPlacement = FLOATING_ELEMENT_PLACEMENT.top,
  value,
  ...restProps
}) {
  const { t } = useTranslation()

  const { overflow, setContentOverflowRef } = useContentOverflow({
    externalRef: ref,
  })

  return (
    <EntityProfileHeaderInfoItemBase
      {...restProps}
      contentExist={!!value}
      value={value}
    >
      <FloatingTooltip
        content={value || t(noDataText)}
        disabled={!overflow}
        placement={tooltipPlacement}
      >
        {value ? (
          <Text
            qaName={QA_NAME_PROFILE_INFO_ITEM_VALUE}
            ref={setContentOverflowRef}
          >
            {value}
          </Text>
        ) : (
          <Text
            disabled
            isSecondary
            qaName={QA_NAME_PROFILE_INFO_ITEM_VALUE}
            ref={setContentOverflowRef}
          >
            {t(noDataText)}
          </Text>
        )}
      </FloatingTooltip>
    </EntityProfileHeaderInfoItemBase>
  )
}

export default EntityProfileHeaderInfoItemText
